import { END_POINTS } from '../helpers';
import { CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
  body: any;
  status: number;
};

export const storeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllStores: builder.query<
      CommonResponseType & { data: any },
      { page: number; limit: number; search: string; status: string }
    >({
      query: ({ page, limit, search, status }) => ({
        url: `${END_POINTS.getStore}?status=${status}&page=${page}&limit=${limit}&search=${search}`,
        method: 'GET',
      }),
    }),
    getStoreById: builder.query<CommonResponseType & { data: any }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getStoreById}/${id}`,
        method: 'GET',
      }),
    }),

    updateStore: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateStore}/${id}`,
        method: 'PUT',
        body,
      }),
    }),

    // addNotification: builder.mutation<CommonResponseType & { data: any }, any>({
    //   query: (body) => ({
    //     url: END_POINTS.notification,
    //     method: "POST",
    //     body,
    //   }),
    // }),

    deleteStore: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteStore}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyGetAllStoresQuery,
  useLazyGetStoreByIdQuery,
  // useLazyGetAllStoresQuery,
  useDeleteStoreMutation,
  useUpdateStoreMutation,
} = storeApi;
